import { Marker } from 'react-mapbox-gl';
import styled from 'styled-components';
import markerImage from './map-marker.svg';

export const MapMarker = styled(Marker).attrs({ anchor: 'bottom' })<{
  number?: number;
}>`
  display: block;
  width: 34px;
  height: 50px;
  background: url(${markerImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

  &::before {
    --size: 26px;

    position: absolute;
    top: 4px;
    left: 4px;
    display: ${({ number }) => (number ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
    width: var(--size);
    height: var(--size);
    color: var(--color-white);
    font-weight: bold;
    font-size: var(--font-size-xx-small);
    font-family: var(--font-heading);
    background-color: var(--color-black);
    border-radius: 100%;
    content: ${({ number }) => `'${number}'` || ''};
  }
`;
